interface DirtyFields {
  entries?: Record<string, Record<string, boolean>>;
}

interface FormWithEntries<T extends { id: string }> {
  entries: Record<string, Omit<T, "id">>;
}

export const convertFormToUpdatePayrollDetails = <T extends { id: string }>(
  values: FormWithEntries<T>,
  dirtyFields: DirtyFields,
): T[] => {
  const dirtyEntryIds = Object.keys(dirtyFields.entries || {});

  return dirtyEntryIds.map((id) => ({
    id,
    ...values.entries[id],
  })) as T[];
};
